import { graphql } from '@/gql/graphql';

export const StatRankingFragment = graphql(/* GraphQL */ `
  fragment StatRanking on badge_widget_column {
    id
    sort_order
    sort_direction
    title
    abbreviation
  }
`);
